<template>
  <div class="card" v-show="currentCardId == 'license-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>免許・資格を入力</h2>
        <p>主要な免許・資格は例文から選ぶことができます</p>
        <p v-if="formatId == 'rirekisho_job_change_old'">
          自動入力を使ってみましょう。主要な免許・資格は例文から選ぶことができます。<span
            style="color: #e3165c"
            >資格等が無い場合は「特になし」と記載し、空白を避けましょう。</span
          >
        </p>
        <el-checkbox v-model="formatData.notDisplayIjyoLicense"
          >【以上】を表示しない</el-checkbox
        >
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <el-button type="success" @click="exampleVisible = true"
            >例文から追加</el-button
          >
          <NewRirekishoExampleSentenceDialog
            :value="exampleVisible"
            name="license-dialog"
            :items="licenseExamples"
            @input="exampleVisible = $event"
            @select="onSelectExample"
          />
        </div>
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.licenseHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.licenseHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'免許・資格を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @add-history-item="addLicenseHistory"
              @delete-history-item="deleteLicenseHistory"
              @move-history-item="moveLicenseHistory"
              @click.native="activateHistoryItem(item.uuid)"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addLicenseHistory()"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.licenseHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
          </div>
        </div>
      </div>
      <div v-if="formatId == 'rirekisho_job_change_old'">
        <p class="guidetxt">免許資格の見本（参考にして作成しましょう）</p>
        <img
          src="/static/img/rirekishoguide/guide05.png"
          alt="免許・資格"
          class="guideimg"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'

const descriptionMaxLength = 80

const props = defineProps<{
  currentCardId?: string
  formatId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
  exampleSentences?: RirekishoExampleSentences
}>()

const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const exampleVisible = ref(false)

const licenseExamples = computed(() => props.exampleSentences?.license || [])

function onSelectExample(item: RirekishoExampleSentence) {
  addLicenseHistory(null, { description: item.description })
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/format-edit/rirekisho-guide';
</style>
